import React, { useState, useEffect } from 'react';
import '../styles/components/cookieConsent.css';

const CONSENT_KEY = 'cookie_consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) {
      // Show banner quickly after first paint settles
      const timer = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(timer);
    } else {
      // Apply stored consent
      applyConsent(JSON.parse(stored));
    }
  }, []);

  const applyConsent = (consent) => {
    if (window.gtag) {
      window.gtag('consent', 'update', {
        ad_storage: consent.ads ? 'granted' : 'denied',
        ad_user_data: consent.ads ? 'granted' : 'denied',
        ad_personalization: consent.ads ? 'granted' : 'denied',
        analytics_storage: consent.analytics ? 'granted' : 'denied',
      });
    }
  };

  const handleAcceptAll = () => {
    const consent = { ads: true, analytics: true, timestamp: Date.now() };
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
    applyConsent(consent);
    setVisible(false);
  };

  const handleRejectNonEssential = () => {
    const consent = { ads: false, analytics: false, timestamp: Date.now() };
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
    applyConsent(consent);
    setVisible(false);
  };

  const handleAcceptAnalyticsOnly = () => {
    const consent = { ads: false, analytics: true, timestamp: Date.now() };
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
    applyConsent(consent);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-banner">
        <div className="cookie-consent-text">
          <p>
            We use cookies to keep the site running smoothly and to understand what content you enjoy.
            {!showDetails && <> <button className="cookie-link-btn" onClick={() => setShowDetails(true)}>Learn more</button></>}
          </p>
          {showDetails && (
            <div className="cookie-consent-details">
              <p><strong>Essential</strong> — Required for the site to work (always active).</p>
              <p><strong>Analytics</strong> — Helps us improve the site by understanding how visitors browse.</p>
              <p><strong>Ads</strong> — Enables personalized ads. May track browsing across sites.</p>
              <p>
                See our <a href="/privacy-policy.html">Privacy Policy</a> for full details.
              </p>
            </div>
          )}
        </div>
        <div className="cookie-consent-actions">
          <button className="cookie-btn cookie-btn-accept" onClick={handleAcceptAll}>
            Accept All
          </button>
          <button className="cookie-btn cookie-btn-secondary" onClick={handleAcceptAnalyticsOnly}>
            Analytics Only
          </button>
          <button className="cookie-btn cookie-btn-reject" onClick={handleRejectNonEssential}>
            Reject All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
